export function BookingDetailPage() {
  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">Détail de la réservation</h1>
      </div>
      <div className="mt-6 bg-white border border-slate-200 rounded-xl p-6 shadow-sm">
        <p className="text-slate-500">
          Les détails de la réservation s'afficheront ici une fois connecté à la base de données.
        </p>
      </div>
    </div>
  );
}
